/**
 * Central configuration for Haryana Roadways Bus Time Table system.
 * Modify the enquiry number or verification date here once, and it will reflect across all pages.
 */

export const ENQUIRY_NUMBER = '01667-220058 / 230001';
export const DATA_LAST_VERIFIED = '2026-10-18';
export const DATA_SOURCE = 'Office of the General Manager, Haryana Roadways, Fatehabad';
export const DATA_SOURCE_HI = 'कार्यालय महाप्रबंधक, हरियाणा रोडवेज, फतेहाबाद';

export const DISCLAIMER_HI = `यह एक अनौपचारिक जानकारी साइट है और हरियाणा रोडवेज से संबद्ध नहीं है। समय बदल सकते हैं। यात्रा से पहले कृपया हरियाणा रोडवेज की पूछताछ पर पुष्टि करें: ${ENQUIRY_NUMBER}`;
export const DISCLAIMER_EN = `This is an unofficial information site and is not affiliated with Haryana Roadways. Timings may change. Please confirm with Haryana Roadways enquiry before travelling: ${ENQUIRY_NUMBER}`;

export const HINDI_PLACES = {
  Fatehabad: 'फतेहाबाद',
  Tohana: 'टोहाना',
  Chandigarh: 'चंडीगढ़',
  Narwana: 'नरवाना',
  Jakhal: 'जाखल',
  Adampur: 'आदमपुर',
  Ratia: 'रतिया',
  Alika: 'अलीका',
  Chopta: 'चौपटा',
  Hanspur: 'हंसपुर',
  Bhuna: 'भूना',
  Kaithal: 'कैथल',
  Bhirdana: 'भिरड़ाना',
  Dadupur: 'दादूपुर',
  Nohar: 'नोहर',
  Ladhuwas: 'लाधुवास',
  Pilchhiya: 'पिलछियां',
  Gorakhpur: 'गोरखपुर',
  Delhi: 'दिल्ली',
  Ajitnagar: 'अजीत नगर',
  Bhadra: 'भादरा',
  Kirdhan: 'किरढ़ान',
  Sirsa: 'सिरसा',
  Hisar: 'हिसार',
  Gurugram: 'गुरुग्राम',
  Panipat: 'पानीपत',
  Rohtak: 'रोहतक',
  Uklana: 'उकलाना',
  Bathinda: 'बठिंडा',
  Budhlada: 'बुढलाडा',
  Haridwar: 'हरिद्वार',
  Karnal: 'करनाल',
  Ludhiana: 'लुधियाना',
  Amritsar: 'अमृतसर',
  Patiala: 'पटियाला',
  Jaipur: 'जयपुर',
  Ganganagar: 'गंगानगर',
  Patran: 'पातड़ां',
  Dhanouri: 'धनौरी',
  Dhamthan: 'धमतान',
  Barwala: 'बरवाला',
  Sangrur: 'संगरूर',
  'MP Rohi': 'एमपी रोही',
  Dhanger: 'ढांगर',
  Khairampur: 'खैरमपुर',
  Dharnia: 'ढारनियां',
  Banawali: 'बनावली',
  'Bhattu Kalan': 'भट्टू कलां',
  Bhattu: 'भट्टू',
  Bighar: 'बीघड़',
  Nagpur: 'नागपुर',
  Aherwan: 'अहैरवां',
  Phoola: 'फूला',
  Nurki: 'नूरकी',
  Hasanga: 'हंसगा',
  Jhalnia: 'झालनियां',
  'Thoba Dhani': 'थोबा ढाणी',
  Barsin: 'बड़सीन',
  Majra: 'माजरा',
  'Bhodia Khera': 'भोड़िया खेड़ा',
  'Dhani Dhaka': 'ढाणी ढाका',
  Palsar: 'पलसर',
  Birabadi: 'बीराबादी',
  Sabarwas: 'सबरवास',
  Karnoli: 'करणोली',
  Ahlisadar: 'अहलीसदर',
  Agroha: 'अग्रोहा',
  'Ding Mandi': 'डिंग मंडी',
  'Ding Road': 'डिंग रोड',
  'Sottar Bhattu': 'सोत्तर भट्टू',
  Sardulgarh: 'सरदूलगढ़',
  Yamunanagar: 'यमुनानगर',
  Ballabgarh: 'बल्लभगढ़',
  Balsamand: 'बालसमंद',
  Shekhupur: 'शेखूपुर',
  Kurukshetra: 'कुरुक्षेत्र',
  Ambala: 'अंबाला',
  Kagdana: 'कागदाना',
  Shahtalai: 'शाहतलाई',
  Shimla: 'शिमला',
  Jhajjar: 'झज्झर',
  Jalalabad: 'जलालाबाद',
  Firozpur: 'फिरोजपुर',
  Jalandhar: 'जालंधर',
  Jammu: 'जम्मू',
  Jind: 'जींद',
  Saniana: 'सनियाना',
  Parta: 'पाबड़ा/परता',
  Gajuwala: 'गाजूवाला',
  Moonak: 'मूनक',
  Damkora: 'दमकोरा',
  Sulhera: 'सुल्हेड़ा',
  'Rajgarh Dhobi': 'राजगढ़ धोबी'
};

export const getHindiPlace = (name) => HINDI_PLACES[name] || name;
